import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaicentraltopunecab() {



  const cardData = {


  keyword: "Mumbai Central to Pune Cab",

  headingDescription: "Trustline Cab provides reliable Mumbai Central to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, railway station transfers, airport connectivity, family trips, and outstation journeys. Whether you need a one-way taxi or round-trip cab, our professional chauffeurs ensure timely pickups, smooth highway travel, and a hassle-free journey from Mumbai Central to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained cars, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Mumbai Central to Pune taxi services.",

  topPlaces: [
    {
      title: "Kharadi",
      description: "Kharadi is one of Pune's fastest-growing business and IT destinations, home to EON IT Park, multinational companies, financial organizations, and modern corporate offices. It is a preferred location for professionals and business travelers."
    },
    {
      title: "Aundh",
      description: "Aundh is a premium Pune locality known for corporate offices, educational institutions, hospitals, restaurants, and upscale residential areas. Its excellent connectivity makes it a popular destination for business and family travel."
    },
    {
      title: "Wakad",
      description: "Wakad is a rapidly developing suburb near Pune's major IT corridors, featuring residential projects, commercial spaces, restaurants, and easy access to Hinjewadi. It is widely preferred by IT professionals and families."
    },
    {
      title: "Chakan Industrial Area",
      description: "Chakan Industrial Area is a major manufacturing and logistics hub in Maharashtra, housing automobile companies, engineering industries, warehouses, and large production units. It attracts industrial visitors and corporate travelers."
    },
    {
      title: "Magarpatta City",
      description: "Magarpatta City is a modern integrated township with IT parks, corporate offices, residential communities, shopping areas, and business facilities. It is a popular destination for professionals and corporate travel."
    },
    {
      title: "Viman Nagar",
      description: "Viman Nagar is a premium locality near Pune Airport, featuring IT companies, hotels, shopping malls, restaurants, and commercial spaces. It is a preferred destination for airport passengers and business visitors."
    },
    {
      title: "Dagdusheth Halwai Ganpati Temple",
      description: "Dagdusheth Halwai Ganpati Temple is one of Pune's most famous cultural and religious landmarks, attracting devotees and tourists throughout the year with its historical importance and spiritual atmosphere."
    },
    {
      title: "Aga Khan Palace",
      description: "Aga Khan Palace is a historic monument in Pune known for its beautiful architecture and connection with India's freedom movement. It is a popular sightseeing destination for history enthusiasts and tourists."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a scenic hill station on the Mumbai-Pune route, famous for waterfalls, viewpoints, caves, and lush green landscapes. It is a popular weekend getaway for travelers from Mumbai and Pune."
    },
    {
      title: "Karla Caves",
      description: "Karla Caves are ancient Buddhist rock-cut monuments near Lonavala featuring impressive architecture, historical carvings, and cultural significance. They are a popular attraction for tourists traveling on the Mumbai-Pune route."
    }
  ],






"services": [
  {
    "name": "Mumbai Central to Pune Taxi",
    "description": "Book Mumbai Central to Pune Taxi for comfortable intercity travel with professional chauffeurs, clean AC vehicles, transparent pricing, and doorstep pickup. Choose Sedan, Swift Dzire, Ertiga, Innova Crysta, SUV, and premium cars for business trips, family travel, airport transfers, and outstation journeys."
  },
  {
    "name": "Taxi from Mumbai Central to Pune",
    "description": "Reserve Taxi from Mumbai Central to Pune with experienced drivers, affordable fares, premium vehicles, luggage support, and safe highway travel for a smooth Mumbai Pune journey."
  },
  {
    "name": "Taxi from Mumbai Central to Pune One Way Cab",
    "description": "Book Taxi from Mumbai Central to Pune One Way Cab for direct destination travel with fixed pricing, no return charges, comfortable AC cars, and professional chauffeur service."
  },
  {
    "name": "Mumbai Central to Pune Drop Taxi",
    "description": "Choose Mumbai Central to Pune Drop Taxi for point-to-point transportation with affordable rates, reliable drivers, clean vehicles, and convenient doorstep drop service."
  },
  {
    "name": "Mumbai Central to Baner Taxi",
    "description": "Book Mumbai Central to Baner Taxi for corporate and personal travel with premium cars, experienced chauffeurs, comfortable seating, and reliable intercity transportation."
  },
  {
    "name": "Mumbai Central to Pune Innova Taxi",
    "description": "Travel with Mumbai Central to Pune Innova Taxi featuring spacious seating, AC comfort, premium interiors, luggage capacity, and professional driver service."
  },
  {
    "name": "Mumbai Central to Pune Ertiga Taxi",
    "description": "Choose Mumbai Central to Pune Ertiga Taxi for family and group travel with affordable fares, comfortable seating, clean vehicles, and reliable chauffeur-driven service."
  },
  {
    "name": "Mumbai Central to Pune Sedan Taxi",
    "description": "Book Mumbai Central to Pune Sedan Taxi for economical and comfortable travel with professional drivers, smooth rides, transparent pricing, and well-maintained vehicles."
  },
  {
    "name": "Mumbai Central to Pune Swift Dzire Taxi",
    "description": "Reserve Mumbai Central to Pune Swift Dzire Taxi for budget-friendly travel with AC comfort, experienced chauffeurs, affordable fares, and dependable service."
  },
  {
    "name": "Mumbai Central to Pune Cab",
    "description": "Book Mumbai Central to Pune Cab for one-way, round-trip, and outstation travel with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicle options."
  },
  {
    "name": "Pune to Mumbai Central Cab",
    "description": "Choose Pune to Mumbai Central Cab for return journeys with professional drivers, clean AC vehicles, flexible booking, and comfortable highway travel."
  },
  {
    "name": "Pune to Mumbai Central Taxi",
    "description": "Book Pune to Mumbai Central Taxi with reliable chauffeurs, affordable pricing, spacious vehicles, and safe intercity transportation."
  },
  {
    "name": "Cab Service in Mumbai Central",
    "description": "Get Cab Service in Mumbai Central for local and outstation travel with premium vehicles, professional drivers, airport transfers, and 24x7 booking support."
  },
  {
    "name": "Cheapest Cab Service in Mumbai",
    "description": "Choose Cheapest Cab Service in Mumbai with affordable fares, transparent pricing, clean vehicles, experienced chauffeurs, and reliable transportation."
  },
  {
    "name": "Best Cab Service in Mumbai",
    "description": "Book Best Cab Service in Mumbai for premium travel solutions with comfortable cars, trained drivers, quick booking, and dependable customer support."
  },
  {
    "name": "Mumbai to Pune Cab Booking",
    "description": "Complete Mumbai to Pune Cab Booking online with instant confirmation, multiple vehicle choices, fixed fares, and hassle-free intercity travel."
  },
  {
    "name": "Mumbai Central Cab Service",
    "description": "Reserve Mumbai Central Cab Service for business trips, family travel, airport transfers, and outstation journeys with reliable chauffeur-driven vehicles."
  },
  {
    "name": "Best Outstation Cab Service in Mumbai",
    "description": "Choose Best Outstation Cab Service in Mumbai for long-distance travel with professional chauffeurs, premium vehicles, affordable packages, and safe journeys."
  },
  {
    "name": "Mumbai Central to Pune Cab",
    "description": "Book Mumbai Central to Pune Cab for comfortable one-way and round-trip travel with experienced drivers, AC vehicles, transparent fares, and flexible schedules."
  },
  {
    "name": "Mumbai Central to Pune Cab Service",
    "description": "Our Mumbai Central to Pune Cab Service provides reliable transportation with premium vehicles, punctual pickup, professional chauffeurs, and affordable pricing."
  },
  {
    "name": "Mumbai Central to Pune Taxi Service",
    "description": "Choose Mumbai Central to Pune Taxi Service for smooth travel with clean cars, experienced drivers, fixed fares, and dependable customer support."
  },
  {
    "name": "Mumbai Central to Pune Cab Booking",
    "description": "Complete Mumbai Central to Pune Cab Booking with quick confirmation, multiple vehicle options, affordable rates, and secure reservation."
  },
  {
    "name": "Cab from Mumbai Central to Pune",
    "description": "Hire Cab from Mumbai Central to Pune with chauffeur-driven vehicles, comfortable seating, luggage space, and reliable long-distance travel service."
  },
  {
    "name": "Mumbai Central to Pune Car Rental",
    "description": "Choose Mumbai Central to Pune Car Rental with Sedan, Ertiga, Innova Crysta, SUV, and premium cars for private and corporate travel."
  },
  {
    "name": "Mumbai Central to Pune One Way Cab",
    "description": "Book Mumbai Central to Pune One Way Cab for direct travel with affordable pricing, professional drivers, and comfortable AC vehicles."
  },
  {
    "name": "Cheap Mumbai Central to Pune Cabs",
    "description": "Select Cheap Mumbai Central to Pune Cabs with budget-friendly fares, clean vehicles, reliable chauffeurs, and comfortable journeys."
  },
  {
    "name": "Mumbai Central to Pune Taxi Fare",
    "description": "Check Mumbai Central to Pune Taxi Fare with transparent charges, affordable packages, and multiple car options including Sedan, Ertiga, and Innova Crysta."
  },
  {
    "name": "Book Mumbai Central to Pune Cab Online",
    "description": "Book Mumbai Central to Pune Cab Online with instant confirmation, easy reservation process, flexible timings, and professional chauffeur assistance."
  }
],

"tableData": [
  ["Mumbai Central to Pune Taxi", "Taxi from Mumbai Central to Pune"],
  ["Taxi from Mumbai Central to Pune One Way Cab", "Mumbai Central to Pune Drop Taxi"],
  ["Mumbai Central to Baner Taxi", "Mumbai Central to Pune Innova Taxi"],
  ["Mumbai Central to Pune Ertiga Taxi", "Mumbai Central to Pune Sedan Taxi"],
  ["Mumbai Central to Pune Swift Dzire Taxi", "Mumbai Central to Pune Cab"],
  ["Pune to Mumbai Central Cab", "Pune to Mumbai Central Taxi"],
  ["Cab Service in Mumbai Central", "Cheapest Cab Service in Mumbai"],
  ["Best Cab Service in Mumbai", "Mumbai to Pune Cab Booking"],
  ["Mumbai Central Cab Service", "Best Outstation Cab Service in Mumbai"],
  ["Mumbai Central to Pune Cab", "Mumbai Central to Pune Taxi Service"],
  ["Mumbai Central to Pune Cab Booking", "Cab from Mumbai Central to Pune"],
  ["Mumbai Central to Pune Car Rental", "Mumbai Central to Pune One Way Cab"],
  ["Cheap Mumbai Central to Pune Cabs", "Mumbai Central to Pune Taxi Fare"],
  ["Book Mumbai Central to Pune Cab Online", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai Central to Pune Cab Service",
    WhyChoosedescription: "Trustline Cab provides comfortable Mumbai Central to Pune cab services with professional drivers, well-maintained vehicles, and dependable intercity travel solutions."
  },
  {
    WhyChooseheading: "Convenient Pickup from Mumbai Central",
    WhyChoosedescription: "Get easy pickup from Mumbai Central Railway Station, hotels, offices, and nearby areas with direct drop at your preferred Pune location."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long Distance Travel",
    WhyChoosedescription: "Our trained chauffeurs ensure a safe and smooth journey with excellent knowledge of the Mumbai-Pune route."
  },
  {
    WhyChooseheading: "Comfortable Cars for Every Requirement",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for individual, family, and group travel."
  },
  {
    WhyChooseheading: "Affordable Mumbai Central Pune Cab Fare",
    WhyChoosedescription: "Enjoy competitive pricing with transparent fare details and no hidden charges before confirming your cab booking."
  },
  {
    WhyChooseheading: "One Way & Round Trip Availability",
    WhyChoosedescription: "Select one-way cabs, return trips, or customized travel plans based on your schedule and destination needs."
  },
  {
    WhyChooseheading: "Ideal for Business & Personal Journeys",
    WhyChoosedescription: "Our Mumbai Central to Pune cabs are suitable for office travel, family visits, airport transfers, medical trips, and personal travel."
  },
  {
    WhyChooseheading: "24/7 Booking Support",
    WhyChoosedescription: "Book your Mumbai Central to Pune cab anytime with quick confirmation and dedicated customer assistance."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Mumbai Central to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable Mumbai Central to Pune cab services for one-way trips, round trips, and corporate travel."
  },
  {
    question: "Can I get pickup from Mumbai Central Railway Station?",
    answer: "Yes, we provide pickup from Mumbai Central Railway Station along with hotels, offices, and nearby Mumbai locations."
  },
  {
    question: "Can I book a one-way cab from Mumbai Central to Pune?",
    answer: "Yes, affordable one-way cab services are available with convenient pickup and direct drop options."
  },
  {
    question: "Which vehicles are available for Mumbai Central to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    question: "Is Mumbai Central to Pune cab service available 24 hours?",
    answer: "Yes, our cab services operate throughout the day and night for comfortable travel at your preferred time."
  },
  {
    question: "Do you provide doorstep pickup in Mumbai?",
    answer: "Yes, doorstep pickup is available from railway stations, hotels, offices, residential areas, and other locations."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the confirmed quotation."
  },
  {
    question: "Can I reserve my cab before the travel date?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and preferred pickup timing."
  },
  {
    question: "Is this service suitable for corporate travelers?",
    answer: "Yes, our Mumbai Central to Pune cab service is ideal for business meetings, employee travel, and professional journeys."
  },
  {
    question: "How can I book Mumbai Central to Pune Cab with Trustline Travels?",
    answer: "Provide your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Bhosale",
    feedback: "The Mumbai Central to Pune cab service was excellent with smooth coordination, timely pickup, and a comfortable vehicle. The driver maintained professionalism throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Shah",
    feedback: "Trustline Travels made our intercity travel simple and convenient. The clean cab, polite driver, and reliable service provided a comfortable journey from Mumbai Central to Pune.",
    rating: 5
  }
];






  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Central to Pune Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/mumbai-central-to-pune-cab.webp",
  "description": "Book Mumbai Central to Pune cab service with Trustline Travels for safe, comfortable, and affordable intercity travel. Get one-way, round-trip, drop taxi, and outstation cab services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/mumbai-central-to-pune-cab"
  }
};




  return (
    <div>
<Helmet>
  <title>Mumbai Central to Pune Cab | One Way Drop Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Mumbai Central to Pune cab with Trustline Travels for reliable and affordable travel. Get one-way drop taxi, round-trip, and private cab services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options available 24x7."
  />

  <meta
    name="keywords"
    content="mumbai central to pune taxi, taxi from mumbai central to pune, taxi from mumbai central to pune one way cab, mumbai central to pune drop taxi, mumbai central to pune taxi, mumbai central to baner taxi, mumbai central to pune innova taxi, mumbai central to pune ertiga taxi, mumbai central to pune sedan taxi, Mumbai Central to Pune Cab, Mumbai Central Pune One Way Taxi, Mumbai Central Pune Outstation Cab, Mumbai Central Pune Airport Taxi, Mumbai Central Pune Car Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/98.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaicentraltopunecab;